export default __webpack_public_path__ + "static/media/5.2b89178f.png";